module.exports = __webpack_public_path__ + "img/BRAND-01.172df32d.jpg";